import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { filter, finalize, first, tap } from "rxjs/operators";
import * as CoursesActions from '../store/courses/courses.actions';
import * as CoursesSelectors from '../store';



@Injectable()
export class AllCoursesResolver  {
  constructor(private store: Store<any>) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.store.pipe(
      select(CoursesSelectors.selectAllCoursesSuccess),
      tap(areLoaded => {
        if (!areLoaded) {
          this.store.dispatch(new CoursesActions.GetAllCourse(''));
        }
      }),
      filter(areLoaded => areLoaded),
      first(),
    );
  }
}
